// Чипчето с масата и със сметката в реда. Клик по него ВЛИЗА в проследяване,
// затова спира събитието: същият клик иначе отваря и модала с детайла.

type Props = {
  label: string;
  title: string;
  onClick: () => void;
};

export const TraceChip = ({ label, title, onClick }: Props) => (
  <button
    type="button"
    title={title}
    onClick={(event) => {
      event.stopPropagation();
      onClick();
    }}
    className="rounded-md border border-transparent bg-fill px-2 py-[3px] font-pos-mono text-[11.5px] font-bold leading-[normal] tabular-nums text-soft transition-colors hover:border-brand-tint2 hover:bg-brand-tint hover:text-brand-deep-ink"
  >
    {label}
  </button>
);
